/** The web scraping benchmark, as published in the public gist. This file is
 *  the site's only copy of these numbers; change them here and in the gist. */
export const SCRAPE_BENCHMARK = {
  gistUrl: 'https://gist.github.com/kev1n/b02e7cb866b563b811c3870df81d1c3f',
  measuredTo: '2026-10-01',
  pages: 100,
  video: { src: '/videos/scrape-router.mp4', poster: '/videos/scrape-router-poster.webp', width: 1920, height: 1080 },
} as const;

export interface BenchService {
  name: string;
  /** our own row, drawn with the AnyAPI mark instead of `logo` */
  self: boolean;
  /** public path of the service's logo; absent on our own row */
  logo?: string;
  /** real pages back out of `pages` */
  total: number;
  /** what the run cost per 1,000 real pages, USD */
  costPer1kUsd: number;
  /** the plan the price needs to be read with: the provider's Hobby plan, or
   *  a monthly fee on top of the per-page price */
  plan?: 'hobby' | { monthlyUsd: number };
  /** the price is a ceiling, not the exact figure */
  priceAtMost?: boolean;
}

/** Highest score first, the order the gist lists them in. */
export const BENCH_SERVICES: BenchService[] = [
  { name: 'AnyAPI', self: true, total: 98, costPer1kUsd: 1.05 },
  {
    name: 'Firecrawl',
    self: false,
    logo: '/benchmark-logos/firecrawl.png',
    total: 90,
    costPer1kUsd: 3.97,
    plan: 'hobby',
  },
  {
    name: 'Bright Data',
    self: false,
    logo: '/benchmark-logos/brightdata.png',
    total: 81,
    costPer1kUsd: 1.5,
  },
  {
    name: 'Jina Reader',
    self: false,
    logo: '/benchmark-logos/jina.png',
    total: 55,
    costPer1kUsd: 0.73,
  },
  {
    name: 'Cloudflare Browser Rendering',
    self: false,
    logo: '/benchmark-logos/cloudflare.svg',
    total: 48,
    costPer1kUsd: 0.1,
    priceAtMost: true,
    plan: { monthlyUsd: 5 },
  },
];
